
import { ApiService } from '..';

export const GeneralEntryService = {
    get(slug) {
        return ApiService.get('entry', slug);
    }
};